import { render, staticRenderFns } from "./GameReport.vue?vue&type=template&id=2760088d&scoped=true"
import script from "./GameReport.vue?vue&type=script&lang=js"
export * from "./GameReport.vue?vue&type=script&lang=js"
import style0 from "./GameReport.vue?vue&type=style&index=0&id=2760088d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2760088d",
  null
  
)

export default component.exports